const GenericButton = ({ btnText, handleClick, loading, isDisabled }) => {
  return (
    <button
      className="btn btn-primary"
      onClick={handleClick}
      disabled={loading || isDisabled}
    >
      {loading ? (
        <>
          <span
            className="spinner-border spinner-border-sm mx-2"
            role="status"
            aria-hidden="true"
          ></span>
        </>
      ) : (
        btnText
      )}
    </button>
  );
};

export default GenericButton;
